<div class="card-background">
  @if (theme) {
    @if (isScootaverseCard) {
      <div class="color-gradient-layer"></div>
    }

    @if (isBackgroundContiguous(theme)) {
      <div
        class="background-image"
        [style.background-image]="roomSetBackgroundImage(theme) ? 'url(' + roomSetBackgroundImage(theme) + ')' : ''"
        [ngClass]="{ '': !roomSetBackgroundImage(theme) }"
      ></div>
    }
    @if (!isBackgroundContiguous(theme) && backgroundHasImages(theme)) {
      <div class="background-parallax">
        @if (theme.colorGradientBackground) {
          <div class="background-no-image" [style.background]="theme.colorGradientBackground"></div>
        } @else if (theme.colorBackground) {
          <div class="background-no-image" [style.background]="theme.colorBackground"></div>
        } @else if (theme.colorPrimary) {
          <div class="background-no-image" [style.background]="theme.colorPrimary"></div>
        }

        <img class="far-layer" [src]="roomImageFarURI(theme)" alt="" />
        <img class="mid-layer" [src]="roomImageMidURI(theme)" alt="" />
        <img class="near-layer" [src]="roomImageNearURI(theme)" alt="" />
      </div>
    }

    @if (!isBackgroundContiguous(theme) && !backgroundHasImages(theme)) {
      @if (theme && theme.type === 2) {
        <div class="background-no-image" [style.background]="theme.colorBackground"></div>
      } @else {
        <div class="background-no-image"></div>
      }
    }
  } @else {
    <div class="color-gradient-layer"></div>
    <div class="background-no-image"></div>
  }

  @if (themeLabel && themeLabel !== '') {
    <div class="theme-name">
      <span>{{ themeLabel }}</span>
    </div>
  }
</div>
